<div class="agenda-page-container">
    <div class="page-content-wrapper">
        <!-- Partie gauche -->
        <div class="left-part" [ngClass]="{'hidden-left-part': !showedLeftPart}">
            <div class="extend-button-wrapper">
                <div class="extend-button" (click)="extendLeftPart()"></div>
            </div>
            <div class="small-calendar" *ngIf="!showedLeftPart"></div>

            <div class="small-agenda-wrapper">


                <div class="small-calendar-navigation">
                    <div class="chevron-button previous hover-pointer" (click)="smallCalendarNavigateToPrevious()">
                    </div>
                    <div class="today-button hover-pointer" (click)="navigateToToday()">AUJOURD'HUI</div>
                    <div class="chevron-button next hover-pointer" (click)="smallCalendarNavigateToNext()"></div>
                </div>
                <div class="current-date">{{ smallCalendarViewDate | date:"MMMM yyyy" }}</div>
                <mwl-calendar-month-view locale="fr" [viewDate]="smallCalendarViewDate"
                    (dayClicked)="monthDayClicked($event)" [weekStartsOn]="1"></mwl-calendar-month-view>
            </div>

            <div class="unplanned-events" mwlDroppable (drop)="unplannedDrop($event.dropData.event)"
                dragOverClass="drag-active">
                <div class="title-wrapper">
                    <span class="title">Rendez-vous à planifier - <strong>{{unplannedEvents.length}}</strong></span>
                    <!-- <span class="extend-button" (click)="extendUnplannedEvents()"
                        [ngClass]="{'hidden-list': !showedUnplannedEvents}"></span> -->
                </div>
                <div class="unplanned-events-list" [ngClass]="{'hidden-list': !showedUnplannedEvents}">
                    <div class="unplanned-event" *ngFor="let event of unplannedEvents" mwlDraggable
                        [dropData]="{ event: event }" (dblclick)="doModifyEvent(event)">
                        <div class="patient-infos" *ngIf="event.meta.patient">
                            <span class="patient-name">{{ event.meta.patient.nom }} {{ event.meta.patient.prenom
                                }}</span>
                            <span class="patient-birth"> ({{ event.meta.patient.dateNaissance }})</span>
                        </div>
                        <div class="patient-infos" *ngIf="!event.meta.patient">
                            <span class="patient-name">Pas de patient</span>
                        </div>
                        <div *ngIf="event.meta.type" class="event-type">{{ event.meta.type.label }}</div>
                        <div *ngIf="!event.meta.type" class="event-type"></div>
                        <!-- <div *ngIf="!event.meta.patient && !event.meta.type && event.meta.infosAccessible"
                            class="no-event-info">Aucune information</div>
                        <div *ngIf="!event.meta.infosAccessible" class="no-event-info">Occupé</div> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- Partie droite -->
        <div class="right-part">
            <!-- Partie haute de l'agenda -->
            <div class="top-agenda">
                <!-- <div class="title-date-wrapper">
                    <div class="title-wrapper">Agenda</div>

                </div> -->
                <div class="settings-buttons-wrapper">
                    <div class="date-select-wrapper">

                        <div class="date-navigation-wrapper">
                            <div class="chevron-button previous hover-pointer" (click)="navigateToPrevious()" title="Précédent"></div>
                        </div>
                        <div class="unity-picker">
                            <frg-form-input *ngIf="formGroup" id="unity" [selectValue]="unitySelectValues" type="text"
                                [formGroup]="formGroup" [control]="formGroup.get('unity')"></frg-form-input>
                        </div>
                        <div class="date-navigation-wrapper">
                            <div class="chevron-button next hover-pointer" (click)="navigateToNext()" title="Suivant"></div>
                        </div>
                    </div>
                    <div class="current-date-wrapper">
                        <div class="current-date" *ngIf="calendarUnity !== calendarViewEnum.Day">{{ GetTitleCalendar() }}</div>
                        <div class="current-date" *ngIf="calendarUnity === calendarViewEnum.Day">{{ viewDate |
                            date:"EEEE d MMMM yyyy" }}</div>
                    </div>
                    <div class="buttons-wrapper">
                        <div class="settings-container">
                            <div class="settings-wrapper" *ngIf="currentResource">
                                <frg-form-input class="no-margin" *ngIf="formGroup" id="resource"
                                    [selectValue]="resourcesLabel" type="text" [formGroup]="formGroup"
                                    [control]="formGroup.get('resource')"></frg-form-input>

                            </div>
                        </div>
                        <!-- <div class="create-buttons">
                            <div class="create-button">
                                <frg-button (activated)="getNextSlot()" [backgroundColor]="'var(--secondary)'">PROCHAIN
                                    RDV
                                    DISPONIBLE</frg-button>
                            </div>
                            <div class="create-button">
                                <frg-button (activated)="createNewEvent()" [backgroundColor]="'var(--primary)'">NOUVEAU
                                    RENDEZ-VOUS</frg-button>
                            </div>
                        </div> -->
                        <div class="search-create-button-container" (click)="getNextSlot()" title="Prochain RDV libre">
                            <div class="search-create-button hover-pointer">
                                <div></div>
                            </div>
                        </div>
                        <div class="create-button-container" (click)="createNewEvent()" title="Ajouter un RDV">
                            <div class="create-button hover-pointer">
                                <div></div>
                            </div>
                        </div>
                        <div class="search-button-container" (click)="openSearch()" title="Rechercher un RDV">
                            <div class="search-button hover-pointer">
                                <div></div>
                            </div>
                        </div>
                        <div class="print-button-container" (click)="doPrintViewAgenda()" title="Imprimer l'agenda">
                            <div class="print-button hover-pointer">
                                <div></div>
                            </div>
                        </div>
                        <!-- <div class="print-button-container" (click)="printRdv()" title="Imprimer les RDV">
                            <div class="print-button hover-pointer">
                                <div></div>
                            </div>
                        </div> -->
                        <div class="settings-button-container" (click)="openSettings()" title="Parametre de l'agenda">
                            <div class="settings-button hover-pointer">
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Header d'options rendez-vous -->
            <div class="top-header" *ngIf="lastEventsClicked.length > 0">
                <div class="sections-wrapper">
                    <div class="top-header-section" (click)="doModifyEvent()"
                        [ngClass]="{ 'inactive': lastEventsClicked.length > 1 }">
                        <span class="section-icon modify"></span>
                        <span *ngIf="!isLastEventReadOnly()" class="section-label">Modifier</span>
                        <span *ngIf="isLastEventReadOnly()" class="section-label">Visualiser</span>
                    </div>
                    <div *ngIf="!isLastEventReadOnly()" class="top-header-section" (click)="doDeleteEvent()">
                        <span class="section-icon delete"></span>
                        <span class="section-label">Supprimer</span>
                    </div>
                    <div *ngIf="!isLastEventReadOnly()" class="top-header-section" (click)="doDuplicateEvent()"
                        [ngClass]="{ 'inactive': lastEventsClicked.length > 1 }">
                        <span class="section-icon duplicate"></span>
                        <span class="section-label">Dupliquer</span>
                    </div>
                    <div *ngIf="!isLastEventReadOnly()" class="top-header-section" (click)="doReportEvent()"
                        [ngClass]="{ 'inactive': lastEventsClicked.length > 1 }">
                        <span class="section-icon report"></span>
                        <span class="section-label">Reporter</span>
                    </div>
                    <!-- <div *ngIf="!isLastEventReadOnly()" class="top-header-section" (click)="doRepeatEvent()"
                        [ngClass]="{ 'inactive': lastEventsClicked.length > 1 }">
                        <span class="section-icon repeat"></span>
                        <span class="section-label">Répéter</span>
                    </div> -->
                </div>
            </div>

            <!-- Header d'options jour / semaine -->
            <div class="top-header" *ngIf="dayHeaderClickedDate && lastEventsClicked.length === 0">
                <div class="sections-wrapper">
                    <div class="top-header-section" (click)="copyEvents('day')">
                        <span class="section-icon add-day"></span>
                        <span class="section-label">Utiliser la journée comme modèle</span>
                    </div>
                    <div class="top-header-section" (click)="copyEvents('week')">
                        <span class="section-icon add-week"></span>
                        <span class="section-label">Utiliser la semaine comme modèle</span>
                    </div>
                </div>
            </div>



            <!-- TEMPLATE D'UN SEGMENT D'HEURE -->
            <ng-template #hourSegmentTemplate let-segment="segment" let-locale="locale"
                let-segmentHeight="segmentHeight" let-isTimeLabel="isTimeLabel" let-daysInWeek="daysInWeek">
                <div [attr.aria-hidden]="{} | calendarA11y : (daysInWeek === 1 ? 'hideDayHourSegment' : 'hideWeekHourSegment')"
                    class="cal-hour-segment" [style.height.px]="segmentHeight" [class.cal-hour-start]="segment.isStart"
                    [class.cal-after-hour-start]="!segment.isStart" [ngClass]="segment.cssClass"
                    [attr.data-segment-hour]="!isTimeLabel ? segment.date : ''" >
                    <div class="cal-time" *ngIf="isTimeLabel">
                        {{ segment.displayDate | calendarDate : (daysInWeek === 1 ? 'dayViewHour' : 'weekViewHour') :
                        locale }}
                    </div>
                </div>
            </ng-template>

            <!-- Partie agenda -->
            <div class="agenda-wrapper" [ngSwitch]="calendarUnity">
                <!-- Vue jour -->
                <mwl-calendar-day-view *ngSwitchCase="calendarViewEnum.Day" locale="fr" [viewDate]="viewDate"
                    [events]="events" [dayStartHour]="agendaStartHour" [dayStartMinute]="agendaStartMinute"
                    [dayEndHour]="agendaEndHour" [dayEndMinute]="agendaEndMinute" [hourSegments]="4"
                    [hourSegmentHeight]="hourHeight" (eventTimesChanged)="eventTimesChanged($event)"
                    (eventClicked)="eventClicked($event)" (hourSegmentClicked)="hourSegmentClicked($event)"
                    [snapDraggedEvents]="false" [weekStartsOn]="1" [hourSegmentTemplate]="hourSegmentTemplate" [refresh]="refresh">

                </mwl-calendar-day-view>

                <!-- Vue semaine -->
                <mwl-calendar-week-view *ngSwitchCase="calendarViewEnum.Week" locale="fr" [viewDate]="viewDate"
                    [events]="events" [dayStartHour]="agendaStartHour" [dayStartMinute]="agendaStartMinute"
                    [dayEndHour]="agendaEndHour" [dayEndMinute]="agendaEndMinute" [hourSegments]="4"
                    [hourSegmentHeight]="hourHeight" (eventClicked)="eventClicked($event)"
                    [refresh]="refresh"
                    (eventTimesChanged)="eventTimesChanged($event)" (hourSegmentClicked)="hourSegmentClicked($event)"
                    [snapDraggedEvents]="false" [weekStartsOn]="1" [hourSegmentTemplate]="hourSegmentTemplate">
                    <!-- (dayHeaderClicked)="dayHeaderClicked($event)"> -->
                </mwl-calendar-week-view>

                <!-- Vue mois -->
                <mwl-calendar-month-view *ngSwitchCase="calendarViewEnum.Month" locale="fr" [viewDate]="viewDate"
                    [events]="events" (eventTimesChanged)="eventTimesChanged($event)" [excludeDays]="excludeDays"
                    [snapDraggedEvents]="false">
                </mwl-calendar-month-view>


            </div>


        </div>
    </div>
</div>

<!-- Backdrop invisible : capte le clic dehors -->
<div
  *ngIf="showContextMenu"
  class="ctx-backdrop"
  (click)="closeContextMenu()">
</div>

<div #ctxMenu class="ctx-menu"
     *ngIf="showContextMenu"
     [ngStyle]="{left: menuPosition.x+'px', top: menuPosition.y+'px'}"
     (click)="$event.stopPropagation()"
     (contextmenu)="$event.preventDefault(); $event.stopPropagation()"
     (mouseleave)="closeContextMenu()">

  <div class="ctx-item" *ngIf="selectedEvent?.meta?.patient?.id" (click)="openPatientFolder(selectedEvent.meta.patient.id)">
    Ouvrir le dossier patient
  </div>

  <button class="ctx-item has-submenu"
          [class.disabled]="isSelectedEventReadOnly()"
          [disabled]="isSelectedEventReadOnly()"
          (mouseenter)="openStatusSubmenu()"
          (mouseleave)="scheduleCloseStatusSubmenu()"
          (click)="toggleStatusSubmenu($event)">
    <span>Statut</span>
    <span class="ctx-arrow">▸</span>

    <!-- Sous-menu -->
    <div class="ctx-submenu"
         *ngIf="showStatusSubmenu"
         (mouseenter)="cancelCloseStatusSubmenu()"
         (mouseleave)="closeStatusSubmenu()"
         (click)="$event.stopPropagation()">
      <button class="ctx-item"
              *ngFor="let s of statusList"
              (click)="onStatusPicked(s.id); $event.stopPropagation()">
        <span class="status-icon" [ngClass]="statusIconClass(s.label)"></span>
        <span>{{ s.label }}</span>
        <span class="check" *ngIf="selectedEvent?.meta?.status?.id === s.id">✓</span>
      </button>
    </div>
  </button>

  <button class="ctx-item" (click)="doModifyEvent(selectedEvent); closeContextMenu()">
    Modifier
  </button>

  <button class="ctx-item" (click)=" doDuplicateEvent(selectedEvent); closeContextMenu()">
    Dupliquer
  </button>

  <button class="ctx-item" (click)="doReportEvent(selectedEvent); closeContextMenu()"
          [disabled]="!selectedEvent">
    Reporter
  </button>

  <div class="ctx-sep"></div>

  <button class="ctx-item danger" (click)="doDeleteEvent(selectedEvent); closeContextMenu()">
    Supprimer
  </button>
</div>
